import React, { useEffect } from "react";
import ClipboardJS from "clipboard";

const ClipboardCopy = ({referralLink}) => {
    useEffect(() => {
        const clipboard = new ClipboardJS("#btn01");

        clipboard.on("success", (e) => {
            console.log("Copied:", e.text);
        });

        clipboard.on("error", (e) => {
            console.error("Copy failed:", e);
        });

        return () => clipboard.destroy();
    }, []);

    return (
        <div className="d-flex px-md-5 py-3 align-items-center">
            <div className="input-group input-group-custom">
                <input
                    id="in01"
                    type="text"
                    style={{backgroundColor:"#23153c",color:'white',borderColor:"white"}}
                    className="form-control"
                    placeholder="BTC Address..."
                    aria-label="BTC Address"
                    aria-describedby="btn01"
                    value={referralLink}
                    readOnly
                />
                <button
                    id="btn01"
                    className="btn btn-secondary"
                    type="button"
                    data-clipboard-target="#in01"
                    title="Copy to Clipboard"
                    style={{backgroundColor:"white",color:'black',borderColor:"black"}}
                >
                    Copy
                </button>
            </div>
        </div>
    );
};

export default ClipboardCopy;
